import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet],
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class AppComponent {
}
